require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.promise');
require('../modules/es7.promise.finally');
require('../modules/es7.promise.try');
module.exports = require('../modules/_core').Promise;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/promise.js
// module id = 142
// module chunks = 0 3 4 7 8 9 10 12 13 16 17 18 20 23 24 25 26 27 30 31 32 33 34 35 36 37 38 39 40 41 43 44 48 49 52 53 54 55 56 59 63 65 66 67 68 72 73 74 77 78 79 82 83 88 89 92 93 94 95 97 100 101 103 104 105 106 109 111 113 118 119 120 121 125 127 129 133 134 135 142 143 144 145 146 147 148 149 150 151 154 155 156 159 162 164 165 166 168 169 170 171 172 173